import React from 'react';

import { PhotosScreen } from '~/components/domain/photos/PhotosScreen';

export default function LatestPhotos() {
  return <PhotosScreen listType="latest" />;
}
